<template>
    <div>
      <h2 class="text-1xl font-bold text-gray-700">
        Cofiguracion de tipo de documentos
      </h2>
      <MainTypeOfDocuments />
    </div>
  </template>
  
  <script>
  import MainTypeOfDocuments from "@/components/ConfigurationModules/TypeDocuments/MainTypeOfDocuments.vue";
import { useRoute } from 'vue-router';
import { onBeforeMount, onMounted } from 'vue';
import { findSubmoduleIdByDescription } from '@/hisAcces';
  export default {
    name: "TypeDocuments",
    components: {
        MainTypeOfDocuments,
    },
  setup() {
    const route = useRoute();
    onBeforeMount(() => {
      if (!findSubmoduleIdByDescription(route.path)) {
        window.location.href = "/login";
      }
    });

    onMounted(() => {
      document.title =
        route.meta.title + process.env.VUE_APP_TITLE ||
        process.env.VUE_APP_TITLE;
    });
  },
  };
  </script>
  